var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.debug)?_c('div',[_c('img',{staticClass:"tile",attrs:{"src":("/tiles/" + _vm.tileName + ".jpg")}}),_vm._v(" "+_vm._s(_vm.id)+" ")]):_c('div',[_c('img',{staticClass:"tile",attrs:{"src":("/tiles/" + _vm.tileName + ".jpg")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }